import { CLUSTER as cluster } from '../../../constants';
import { ComscoreTracker } from '@buzzfeed/third-party-analytics';

export async function trackComscorePageview(extraParams) {
  new ComscoreTracker({ client: 'bpage', cluster, extraParams });
}
